/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { Label } from '@bottlebooks/gatsby-design-system';
import { findRoomByStandName } from '@bottlebooks/gatsby-plugin-california-pdf/src/templates/VieVinum/helpers/rooms';
import { jsx } from 'theme-ui';

export * from '@bottlebooks/gatsby-theme-event/src/components/Exhibitor/ExhibitorStand';

export default function ExhibitorStand({ exhibitor, ...rest }) {
  if (!exhibitor?.stand?.name) return null;
  const standName = exhibitor.stand.name;
  const room = findRoomByStandName(standName);
  return (
    <Label {...rest}>
      <span sx={{ color: room?.colors?.primary }}>{standName}</span>
    </Label>
  );
}
